// /* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable @typescript-eslint/no-unused-vars */
// import { useEffect, useState, forwardRef, useImperativeHandle } from "react";
// import { IconX } from "@tabler/icons-react";
// import FileUploader from "../../../components/common/FileUploader";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
// import toast from "react-hot-toast";
// import {
//   useItemBulkDocMutation,
//   useFetchItemTemplate,
//   useFetchProductItemData,
// } from "../../../apis/productApis";
// import {
//   styleAndProtectDummyRow,
//   cleanUploadedExcelFile,
// } from "../../../utilities/bulkUploadHelper";
// import { useLanguage } from "../../../context/LanguageContext";

// type ItemBulkUploadModalsProps = {
//   onClose: () => void;
//   onResponseOpen: () => void;
//   setItemBulkResponse: React.Dispatch<React.SetStateAction<any>>;
//   refetchTable: () => void;
//   hideHeader?: boolean;
// };

// const ItemBulkUploadModals = forwardRef<
//   { submit: () => void },
//   ItemBulkUploadModalsProps
// >(({ onClose, onResponseOpen, setItemBulkResponse, refetchTable, hideHeader = false }, ref) => {
//   const { t } = useLanguage();
//   const [file, setFile] = useState<File | null>(null);

//   const { mutate: uploadDocMutate, isPending: isBulkUploading } =
//     useItemBulkDocMutation();
//   const { data: templateData, refetch: fetchTemplates } =
//     useFetchItemTemplate();

//   const handleUploadDoc = async () => {
//     if (!file) {
//       toast.error(t("Please select a file to upload"));
//       return;
//     }
//     const cleanedFile = await cleanUploadedExcelFile(file, templateData?.[0]);
//     uploadDocMutate(
//       { item: cleanedFile },
//       {
//         onSuccess: (data: any) => {
//           setItemBulkResponse(data.data);
//           onClose();
//           refetchTable();
//           toast.success(t("File uploaded successfully, processing..."));
//         },
//         onError: (error: any) => {
//           console.log(error, "error");
//           toast.error(t(String(error)));
//         },
//       }
//     );
//   };

//   useImperativeHandle(ref, () => ({
//     submit: handleUploadDoc,
//   }));

//   const handleDownloadTemplate = async () => {
//     if (!templateData || templateData.length === 0) {
//       toast.error(t("Template structure is not loaded yet"));
//       return;
//     }

//     const firstItem = templateData[0] || {};
//     const templateObj = firstItem.template || firstItem;
//     const categories: string[] = firstItem.categories || [];
//     const subCategories: string[] = firstItem.subCategories || [];
//     const categoryPairs: { category: string; subCategory: string }[] = firstItem.categoryPairs || [];

//     const workbook = new ExcelJS.Workbook();
//     const worksheet = workbook.addWorksheet("Item Template");

//     // Row 1: Info
//     const infoRow = worksheet.addRow([
//       "This template is for importing item/product data. Fields in red are mandatory; others are optional. Note: If Expiry is YES, Expiry Date (YYYY-MM-DD) is required. If Expiry is NO, Expiry Date is optional. Refer to the 'Reference' sheet for active Categories and Sub Categories.",
//     ]);
//     worksheet.mergeCells(`A1:AC1`);
//     infoRow.eachCell((cell: any) => {
//       cell.fill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: { argb: "E2EFD9" },
//       };
//       cell.font = {
//         name: "Arial",
//         size: 10,
//         bold: true,
//         color: { argb: "212121" },
//       };
//       cell.alignment = {
//         horizontal: "center",
//         vertical: "middle",
//         wrapText: true,
//       };
//       cell.border = {
//         top: { style: "thin", color: { argb: "FF000000" } },
//         left: { style: "thin", color: { argb: "FF000000" } },
//         bottom: { style: "thin", color: { argb: "FF000000" } },
//         right: { style: "thin", color: { argb: "FF000000" } },
//       };
//     });

//     infoRow.height = 25;

//     // Row 2: Validation row
//     const validations = [
//       // Required (1 - 12)
//       "Item Name is required",
//       "SKU is required",
//       "Category name is required",
//       "Sub Category name is required",
//       "Storage Type (PALLETS / BINS) is required",
//       "Capacity is required",
//       "Minimum Quantity is required",
//       "Length is required",
//       "Width is required",
//       "Height is required",
//       "Weight is required",
//       "Expiry (YES / NO) is required",

//       // Optional (13 - 29)
//       "Commodity is optional",
//       "Import Commodity is optional",
//       "Dangerous Goods (YES / NO) is optional",
//       "HS Code is optional",
//       "Price 1 is optional",
//       "Price 2 is optional",
//       "Discount is optional",
//       "Minimum Order is optional",
//       "Short Description is optional",
//       "Long Description is optional",
//       "Product Tags (comma-separated) is optional",
//       "Variant SKU is optional",
//       "Variant Name (e.g. Size/Color) is optional",
//       "Variant Value (e.g. 60 Tablets/Black) is optional",
//       "Variant Price is optional",
//       "Expiry Date (YYYY-MM-DD) is required when Expiry is YES (otherwise optional)",
//       "Terms and Conditions is optional",
//     ];

//     const validationRow = worksheet.addRow(validations);
//     validationRow.eachCell((cell: any) => {
//       const colIndex = Number(cell.col);
//       // Red for required (Cols 1-12), yellow for optional (Cols 13-29)
//       const isRequired = colIndex <= 12;
//       const fillColor = isRequired ? "FFCCCC" : "FFEB9C";

//       cell.fill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: { argb: fillColor },
//       };

//       cell.alignment = {
//         horizontal: "center",
//         vertical: "middle",
//         wrapText: true,
//       };

//       cell.font = { color: { argb: "212121" }, size: 9 };

//       cell.border = {
//         top: { style: "thin", color: { argb: "FF000000" } },
//         left: { style: "thin", color: { argb: "FF000000" } },
//         bottom: { style: "thin", color: { argb: "FF000000" } },
//         right: { style: "thin", color: { argb: "FF000000" } },
//       };
//     });
//     validationRow.height = 45;

//     // Row 3: Headings
//     const headings = Object.keys(templateObj || {});
//     const headingsRow = worksheet.addRow(headings);

//     headingsRow.eachCell((cell: any) => {
//       cell.fill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: { argb: "217447" },
//       };
//       cell.font = { name: "Arial", bold: true, color: { argb: "ffffff" } };
//       cell.alignment = {
//         horizontal: "center",
//         vertical: "middle",
//         wrapText: true,
//       };
//       cell.border = {
//         top: { style: "thin", color: { argb: "FF000000" } },
//         left: { style: "thin", color: { argb: "FF000000" } },
//         bottom: { style: "thin", color: { argb: "FF000000" } },
//         right: { style: "thin", color: { argb: "FF000000" } },
//       };
//     });
//     headingsRow.height = 25;

//     // Row 4: Dummy Data Row
//     let dummyRow: ExcelJS.Row | undefined;
//     if (templateObj) {
//       const dummyValues = Object.values(templateObj);
//       dummyRow = worksheet.addRow(dummyValues);
//       dummyRow.eachCell((cell: any) => {
//         cell.font = { name: "Arial", size: 10, color: { argb: "212121" } };
//         cell.alignment = {
//           horizontal: "center",
//           vertical: "middle",
//           wrapText: true,
//         };
//         cell.border = {
//           top: { style: "thin", color: { argb: "FF000000" } },
//           left: { style: "thin", color: { argb: "FF000000" } },
//           bottom: { style: "thin", color: { argb: "FF000000" } },
//           right: { style: "thin", color: { argb: "FF000000" } },
//         };
//       });
//       dummyRow.height = 20;
//     }

//     // Adjust column widths
//     worksheet.columns = headings.map(() => ({ width: 22 }));

//     await styleAndProtectDummyRow(worksheet, dummyRow);

//     // Create Sheet 2: Reference Data
//     const refSheet = workbook.addWorksheet("Reference");
//     const uniqueCategories = Array.from(new Set(categories.filter(Boolean)));
//     const uniqueSubCategories = Array.from(new Set(subCategories.filter(Boolean)));
//     const pairStrings = categoryPairs.map((p) => `${p.category} -> ${p.subCategory}`);

//     const refHeaders = [
//       `Categories (${uniqueCategories.length})`,
//       `Sub Categories (${uniqueSubCategories.length})`,
//       `Active Category & SubCategory Pairs (${pairStrings.length})`,
//     ];

//     const refHeaderRow = refSheet.addRow(refHeaders);
//     refHeaderRow.eachCell((cell: any) => {
//       cell.font = { name: "Arial", bold: true, color: { argb: "ffffff" } };
//       cell.fill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: { argb: "1B5E20" },
//       };
//       cell.alignment = { horizontal: "center", vertical: "middle" };
//       cell.border = {
//         top: { style: "thin", color: { argb: "FF000000" } },
//         left: { style: "thin", color: { argb: "FF000000" } },
//         bottom: { style: "thin", color: { argb: "FF000000" } },
//         right: { style: "thin", color: { argb: "FF000000" } },
//       };
//     });
//     refHeaderRow.height = 25;

//     const maxRefRows = Math.max(
//       uniqueCategories.length,
//       uniqueSubCategories.length,
//       pairStrings.length
//     );

//     for (let i = 0; i < maxRefRows; i++) {
//       const row = refSheet.addRow([
//         uniqueCategories[i] || "",
//         uniqueSubCategories[i] || "",
//         pairStrings[i] || "",
//       ]);
//       row.eachCell((cell: any) => {
//         cell.alignment = { horizontal: "center", vertical: "middle" };
//       });
//     }

//     refSheet.columns = [
//       { width: 32 },
//       { width: 32 },
//       { width: 48 },
//     ];

//     // Export
//     const buffer = await workbook.xlsx.writeBuffer();
//     saveAs(new Blob([buffer]), "items-template.xlsx");
//   };

//   useEffect(() => {
//     fetchTemplates();
//   }, []);

//   return (
//     <div className="relative flex flex-col h-full">
//       {!hideHeader && (
//         <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-white">
//           <h2 className="text-xl font-semibold text-[#212121]">
//             {t("Bulk Upload Items")}
//           </h2>

//           <div className="flex items-center gap-3">
//             <button
//               onClick={handleUploadDoc}
//               disabled={isBulkUploading}
//               className="px-4 py-1.5 text-xs font-bold bg-[#FBD037] border border-[#FBD037] text-[#212121] rounded-lg hover:bg-yellow-400 transition"
//             >
//               {isBulkUploading ? t("Uploading...") : t("Submit")}
//             </button>

//             <button
//               onClick={onClose}
//               className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition-colors text-slate-700"
//               title="Close"
//             >
//               <IconX size={16} stroke={1.5} />
//             </button>
//           </div>
//         </div>
//       )}

//       <div className="space-y-4 p-4 overflow-y-auto">
//         <FileUploader
//           name="item"
//           img="/img/upload-img.png"
//           title={t("Upload Excel File")}
//           message={t("Upload a CSV or Excel file only (Max size: 2 MB).")}
//           classNameMain="bg-transparent border-none flex items-center gap-3"
//           fileVal={file}
//           setFileVal={(file: any) => {
//             setFile(file);
//           }}
//           showPreview={true}
//           required
//         />

//         {file && (
//           <p className="text-sm text-green-600 font-medium bg-green-50 px-3 py-2 rounded-md border border-green-200">
//             {t("Selected File: ")}{file.name}
//           </p>
//         )}

//         <ul className="list-disc px-5 text-sm text-[#1E293B] font-medium space-y-1">
//           <li>{t("Download the Excel template before uploading.")}</li>
//           <li>{t("Do not change column headers or structure.")}</li>
//           <li>{t("Fields marked in red are required; fields in yellow are optional.")}</li>
//           <li>{t("Ensure Category and Sub Category names exist in your database.")}</li>
//         </ul>

//         <div className="flex flex-wrap items-center justify-between gap-4 p-3 rounded-xl border border-gray-200">
//           <p className="text-xs text-[#212121] font-medium">
//             <b>{t("Note")}</b> {t(": Please upload the file in the same format as the downloaded template file.")}
//           </p>
//           <button
//             onClick={handleDownloadTemplate}
//             className="bg-[#000000] text-white flex items-center space-x-2 px-4 py-2.5 rounded-md text-sm font-semibold whitespace-nowrap hover:bg-black/90 transition-colors"
//           >
//             <img src="/img/csvxl.svg" alt="" />
//             <span>{t("Download Template")}</span>
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// });

// export default ItemBulkUploadModals;


/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { IconX } from "@tabler/icons-react";
import FileUploader from "../../../components/common/FileUploader";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import toast from "react-hot-toast";
import {
  useItemBulkDocMutation,
  useFetchItemTemplate,
  useFetchProductItemData,
} from "../../../apis/productApis";
import {
  styleAndProtectDummyRow,
  cleanUploadedExcelFile,
} from "../../../utilities/bulkUploadHelper";
import { useLanguage } from "../../../context/LanguageContext";

type ItemBulkUploadModalsProps = {
  onClose: () => void;
  onResponseOpen: () => void;
  setItemBulkResponse: React.Dispatch<React.SetStateAction<any>>;
  refetchTable: () => void;
  hideHeader?: boolean;
};

const ItemBulkUploadModals = forwardRef<
  { submit: () => void },
  ItemBulkUploadModalsProps
>(({ onClose, onResponseOpen, setItemBulkResponse, refetchTable, hideHeader = false }, ref) => {
  const { t } = useLanguage();
  const [file, setFile] = useState<File | null>(null);

  const { mutate: uploadDocMutate, isPending: isBulkUploading } =
    useItemBulkDocMutation();
  const { data: templateData, refetch: fetchTemplates } =
    useFetchItemTemplate();

  const handleUploadDoc = async () => {
    if (!file) {
      toast.error(t("Please select a file to upload"));
      return;
    }
    const cleanedFile = await cleanUploadedExcelFile(file, templateData?.[0]);
    uploadDocMutate(
      { item: cleanedFile },
      {
        onSuccess: (data: any) => {
          setItemBulkResponse(data.data);
          onClose();
          refetchTable();
          toast.success(t("File uploaded successfully, processing..."));
        },
        onError: (error: any) => {
          console.log(error, "error");
          toast.error(t(String(error)));
        },
      }
    );
  };

  useImperativeHandle(ref, () => ({
    submit: handleUploadDoc,
  }));

  const handleDownloadTemplate = async () => {
    if (!templateData || templateData.length === 0) {
      toast.error(t("Template structure is not loaded yet"));
      return;
    }

    const firstItem = templateData[0] || {};
    const templateObj = firstItem.template || firstItem;
    const categories: string[] = firstItem.categories || [];
    const subCategories: string[] = firstItem.subCategories || [];
    const categoryPairs: { category: string; subCategory: string }[] = firstItem.categoryPairs || [];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Item Template");

    // Row 1: Info
    const infoRow = worksheet.addRow([
      "This template is for importing item/product data. Fields in red are mandatory; others are optional. Refer to the 'Reference' sheet for active Categories and Sub Categories.",
    ]);
    worksheet.mergeCells(`A1:Z1`);
    infoRow.eachCell((cell: any) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E2EFD9" },
      };
      cell.font = {
        name: "Arial",
        size: 10,
        bold: true,
        color: { argb: "212121" },
      };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };
      cell.border = {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      };
    });

    infoRow.height = 25;

    // Row 2: Validation row
    const validations = [
      // Required (1 - 11)
      "Item Name is required",
      "SKU is required",
      "Category name is required",
      "Sub Category name is required",
      "Storage Type (PALLETS / BINS) is required",
      "Capacity is required",
      "Minimum Quantity is required",
      "Weight is required",
      "Expiry (YES / NO) is required",
      "Dangerous Goods (YES / NO) is required",
      "Compliance (YES / NO) is required",

      // Optional (12 - 26)
      "Length is optional",
      "Width is optional",
      "Height is optional",
      "Price 1 is optional",
      "Price 2 is optional",
      "Discount is optional",
      "Minimum Order is optional",
      "Short Description is optional",
      "Long Description is optional",
      "Product Tags (comma-separated) is optional",
      "Variant SKU is optional",
      "Variant Name (e.g. Size/Color) is optional",
      "Variant Value (e.g. 60 Tablets/Black) is optional",
      "Variant Price is optional",
      "Terms and Conditions is optional",
    ];

    const validationRow = worksheet.addRow(validations);
    validationRow.eachCell((cell: any) => {
      const colIndex = Number(cell.col);
      // Red for required (Cols 1-11), yellow for optional (Cols 12-26)
      const isRequired = colIndex <= 11;
      const fillColor = isRequired ? "FFCCCC" : "FFEB9C";

      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: fillColor },
      };

      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };

      cell.font = { color: { argb: "212121" }, size: 9 };

      cell.border = {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      };
    });
    validationRow.height = 45;

    // Row 3: Headings
    const headings = Object.keys(templateObj || {});
    const headingsRow = worksheet.addRow(headings);

    headingsRow.eachCell((cell: any) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "217447" },
      };
      cell.font = { name: "Arial", bold: true, color: { argb: "ffffff" } };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };
      cell.border = {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      };
    });
    headingsRow.height = 25;

    // Row 4: Dummy Data Row
    let dummyRow: ExcelJS.Row | undefined;
    if (templateObj) {
      const dummyValues = Object.values(templateObj);
      dummyRow = worksheet.addRow(dummyValues);
      dummyRow.eachCell((cell: any) => {
        cell.font = { name: "Arial", size: 10, color: { argb: "212121" } };
        cell.alignment = {
          horizontal: "center",
          vertical: "middle",
          wrapText: true,
        };
        cell.border = {
          top: { style: "thin", color: { argb: "FF000000" } },
          left: { style: "thin", color: { argb: "FF000000" } },
          bottom: { style: "thin", color: { argb: "FF000000" } },
          right: { style: "thin", color: { argb: "FF000000" } },
        };
      });
      dummyRow.height = 20;
    }

    // Adjust column widths
    worksheet.columns = headings.map(() => ({ width: 22 }));

    await styleAndProtectDummyRow(worksheet, dummyRow);

    // Create Sheet 2: Reference Data
    const refSheet = workbook.addWorksheet("Reference");
    const uniqueCategories = Array.from(new Set(categories.filter(Boolean)));
    const uniqueSubCategories = Array.from(new Set(subCategories.filter(Boolean)));
    const pairStrings = categoryPairs.map((p) => `${p.category} -> ${p.subCategory}`);

    const refHeaders = [
      `Categories (${uniqueCategories.length})`,
      `Sub Categories (${uniqueSubCategories.length})`,
      `Active Category & SubCategory Pairs (${pairStrings.length})`,
    ];

    const refHeaderRow = refSheet.addRow(refHeaders);
    refHeaderRow.eachCell((cell: any) => {
      cell.font = { name: "Arial", bold: true, color: { argb: "ffffff" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "1B5E20" },
      };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      };
    });
    refHeaderRow.height = 25;

    const maxRefRows = Math.max(
      uniqueCategories.length,
      uniqueSubCategories.length,
      pairStrings.length
    );

    for (let i = 0; i < maxRefRows; i++) {
      const row = refSheet.addRow([
        uniqueCategories[i] || "",
        uniqueSubCategories[i] || "",
        pairStrings[i] || "",
      ]);
      row.eachCell((cell: any) => {
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });
    }

    refSheet.columns = [
      { width: 32 },
      { width: 32 },
      { width: 48 },
    ];

    // Export
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "items-template.xlsx");
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  return (
    <div className="relative flex flex-col    rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      {!hideHeader && (
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 ">
          <h2 className="text-xl font-semibold text-[#212121]">
            {t("Bulk Upload Items")}
          </h2>

          <div className="flex items-center gap-2">
            <button
              onClick={handleUploadDoc}
              disabled={isBulkUploading}
              className="px-4 py-1.5 rounded-lg text-xs font-semibold transition border border-[#FBD037] bg-[#FBD037] hover:bg-amber-400 text-[#000000] disabled:opacity-50 disabled:cursor-not-allowed shadow-sm cursor-pointer"
            >
              {isBulkUploading ? t("Uploading...") : t("Submit")}
            </button>

            <button
              onClick={onClose}
              className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition-colors text-slate-700 cursor-pointer"
              title="Close"
            >
              <IconX size={16} stroke={1.5} />
            </button>
          </div>
        </div>
      )}

      <div className="space-y-4 p-6 overflow-y-auto">
        <FileUploader
          name="item"
          img="/img/upload-img.png"
          title={t("Upload Excel File")}
          message={t("Upload a CSV or Excel file only (Max size: 2 MB).")}
          classNameMain="bg-transparent border-none flex items-center gap-3"
          fileVal={file}
          setFileVal={(file: any) => {
            setFile(file);
          }}
          showPreview={true}
          required
        />

        {file && (
          <p className="text-sm text-green-600 font-medium bg-green-50 px-3 py-2 rounded-md border border-green-200">
            {t("Selected File: ")}{file.name}
          </p>
        )}

        <ul className="list-disc px-5 text-sm text-[#1E293B] font-medium space-y-1">
          <li>{t("Download the Excel template before uploading.")}</li>
          <li>{t("Do not change column headers or structure.")}</li>
          <li>{t("Fields marked in red are required; fields in yellow are optional.")}</li>
          <li>{t("Ensure Category and Sub Category names exist in your database.")}</li>
        </ul>

        <div className="flex flex-wrap items-center justify-between gap-4 bg-yellow-50 px-4 py-2.5 rounded-md border border-[#D2D2D2]/50">
          <p className="text-xs text-[#212121] font-medium">
            <b>{t("Note")}</b> {t(": Please upload the file in the same format as the downloaded template file.")}
          </p>
          <button
            onClick={handleDownloadTemplate}
            className="bg-[#000000] text-white flex items-center space-x-2 px-2 py-2 rounded-md text-xs font-semibold whitespace-nowrap hover:bg-black/90 transition-colors disabled:opacity-60 shrink-0 cursor-pointer"
          >
            <img src="/img/csvxl.svg" alt="" className="w-4 h-4" />
            <span>{t("Download")}</span>
          </button>
        </div>
      </div>
    </div>
  );
});

export default ItemBulkUploadModals;